<template>
  <div>
    <div class="content-devx">
      <DxForm
        id="costForm"
      >
        <DxGroupItem
          css-class="content-combo"
          :caption="$t('ManurePage_navbar_title')"
          :col-count="1"
        />
      </DxForm>
    </div>
    <div
      class="content-devx transparent headers-initial"
      style="padding: 1rem 0 !important;"
    >
      <div
        style="display: flex; justify-content: center !important; align-items: center; width: auto"
      >
        <DxScrollView
          scroll-by-content
          scroll-by-thumb
          direction="both"
        >
          <DxDataGrid
            id="manureGH"
            :data-source="listManure"
            :allow-column-reordering="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="false"
            :column-auto-width="true"
            :row-alternation-enabled="false"
            :word-wrap-enabled="true"
            :column-hiding-enabled="true"
            no-data-text="Sin datos"
            @file-saving="onFileSaving"
            @row-removed="onRemovedRow"
          >
            <DxSelection
              mode="single"
            />
            <DxExport
              :enabled="true"
              :texts="{exportAll: 'Exportar',}"
              file-name="Base de Datos - ESTIÉRCOL - Invernadero"
            />
            <DxPaging :page-size="10" />
            <DxPager
              :show-page-size-selector="true"
              :show-info="true"
              info-text="Página {0} de {1} ({2} elementos)"
              :allowed-page-sizes="['5', '10', '20', '30', '60']"
            />
            <DxHeaderFilter :visible="true" />
            <DxSearchPanel
              text=""
              :visible="true"
              :width="200"
              :placeholder="$t('Search_placeholder')"
            />
            <DxColumnFixing :enabled="true" />
            <DxEditing
              :allow-deleting="showActions && allowDeleting"
              :confirm-delete="true"
              mode="row"
            >
              <DxTexts
                :confirm-delete-message="$t('Confirm_Delete_Text')"
                :confirm-delete-title="$t('Confirm_Delete_Title')"
                edit-row="Editar"
                delete-row="Eliminar"
                save-row-changes="Guardar"
                cancel-row-changes="Cancelar"
                yes="OK"
              />
            </DxEditing>
            <DxColumn
              data-field="name"
              :caption="$t('registerProject.popPupManure.name')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="N"
              :caption="$t('registerProject.popPupManure.totalContentN')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="dry"
              :caption="$t('registerProject.popPupManure.dryMatter')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="density"
              :caption="$t('registerProject.popPupManure.density')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="year_1"
              :caption="$t('registerProject.popPupManure.mineralizationRateYear1')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="year_2"
              :caption="$t('registerProject.popPupManure.mineralizationRateYear2')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="year_3"
              :caption="$t('registerProject.popPupManure.mineralizationRateYear3')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="year_4"
              :caption="$t('registerProject.popPupManure.mineralizationRateYear4')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              v-if="showActions"
              type="buttons"
              caption="Acciones"
              :fixed="false"
            />
          </DxDataGrid>
        </DxScrollView>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumnFixing,
  DxHeaderFilter,
  DxPager,
  DxSelection, DxEditing, DxTexts,
} from 'devextreme-vue/data-grid';
import { mapState } from 'vuex';
import { DxForm, DxGroupItem } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DEVICE_PLATFORM } from '../../../js/constants';
import Api from '../../../services/Api';

export default {
  name: 'ManureGreenhouse',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumnFixing,
    DxHeaderFilter,
    DxPager,
    DxSelection,
    DxForm,
    DxGroupItem,
    DxScrollView,
    DxEditing,
    DxTexts,
  },
  props: {
    listManure: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showActions() {
      if (this.listManure && this.listManure.length > 0) {
        return this.listManure.some((item) => item.owner !== null);
      }
      return false;
    },
    ...mapState('authentication', [
      'selection',
    ]),
  },
  methods: {
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        cordova.plugins.saveDialog.saveFile(e.data, 'Base de Datos - ESTIÉRCOL - Invernadero.xlsx').then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
    async onRemovedRow(e) {
      try {
        this.$f7.preloader.show();
        await Api.deleteTable('manure', e.data.id);
      } catch (reason) {
        const message = this.$helpers.getFilteredErrorMessage(reason);
        if (message.includes('incorrect authentication')) {
          this.$f7.dialog.alert(this.$t(message));
        }
        if (message.includes('default_') && !message.includes('404')) {
          this.$f7.dialog.alert(message.split('_').pop());
        } else if (!message.includes('404')) {
          this.$f7.dialog.alert(this.$t(message));
        }
      } finally {
        this.$f7.preloader.hide();
      }
    },
    allowDeleting(e) {
      return e.row.data.owner !== null;
    },
  },
};
</script>
  <style
    lang="scss"
    scoped
  >
    .boton-greenHouse {
    background: #FF7F26;
    height: 30px;
    width: 100px;
    margin-top: 60px;
    text-align: center;
    }
    .boton-openAir {
    background: #51A411;
    height: 30px;
    width: 100px;
    margin-top: 60px;
    text-align: center;
    }
    .content-checkbox {
    padding-top: 50px;
    padding-left: 40px;
    }
  </style>
